import AttachmentsEditView from '@/views/Attachments/EditView';
import AttachmentsIndexView from '@/views/Attachments/IndexView';
import AttachmentsNewView from '@/views/Attachments/NewView';
import AttachmentsView from '@/views/AttachmentsView';
import BrandsEditView from '@/views/Brands/EditView';
import BrandsIndexView from '@/views/Brands/IndexView';
import BrandsNewView from '@/views/Brands/NewView';
import BrandsView from '@/views/BrandsView';
import ContractRevisionsView from '@/views/Contracts/RevisionsView';
import ContractsEditRevisionView from '@/views/Contracts/EditRevisionView';
import ContractsEditView from '@/views/Contracts/EditView';
import ContractShowView from '@/views/Contracts/ShowView';
import ContractsIndexView from '@/views/Contracts/IndexView';
import ContractsNewRevisionView from '@/views/Contracts/NewRevisionView';
import ContractsNewView from '@/views/Contracts/NewView';
import ContractsView from '@/views/ContractsView';
import ErrorsView from '@/views/ErrorsView';
import ForbiddenView from '@/views/Errors/ForbiddenView';
import HomeView from '@/views/HomeView';
import ImportReportsIndexView from '@/views/ImportReports/IndexView';
import ImportReportsShowView from '@/views/ImportReports/ShowView';
import ImportReportsView from '@/views/ImportReportsView';
import MaintenanceView from '@/views/MaintenanceView';
import MaintenanceIndexView from '@/views/Maintenance/MaintenanceIndexView';
import KompaView from '@/views/KompaView';
import KompaIndexView from '@/views/Kompa/IndexView';
import CreateKompaProductView from '@/views/Kompa/CreateKompaProductView';
import EditKompaProduct from '@/views/Kompa/EditView';
import EditKompaAdapters from '@/views/Kompa/EditAdaptersView';
import EditKompaAppliances from '@/views/Kompa/EditAppliancesView';
import EditKompaOutdoor from '@/views/Kompa/EditOutdoorView';
import EditKompaCameras from '@/views/Kompa/EditCamerasView';
import EditKompaDoorLocks from '@/views/Kompa/EditDoorLocksView';
import EditKompaExtensions from '@/views/Kompa/EditExtensionsView';
import EditKompaClimateDevices from '@/views/Kompa/EditClimateDevicesView';
import EditKompaGatewayBridges from '@/views/Kompa/EditGatewayBridgesView';
import EditKompaIntegratedSystems
  from '@/views/Kompa/EditIntegratedSystemsView';
import EditKompaInternetRouters from '@/views/Kompa/EditInternetRoutersView';
import EditKompaLightnings from '@/views/Kompa/EditLightningsView';
import EditKompaMotionSensors from '@/views/Kompa/EditMotionSensorsView';
import EditKompaMountedDevices from '@/views/Kompa/EditMountedDevicesView';
import EditKompaProtocols from '@/views/Kompa/EditProtocolsView';
import EditKompaRemoteControls from '@/views/Kompa/EditRemoteControlsView';
import EditKompaShutterAndGates from '@/views/Kompa/EditShutterAndGatesView';
import EditKompaSirens from '@/views/Kompa/EditSirensView';
import EditKompaSmokeSensors from '@/views/Kompa/EditSmokeSensorsView';
import EditKompaSpeakers from '@/views/Kompa/EditSpeakersView';
import EditKompaVariousSensors from '@/views/Kompa/EditVariousSensorsView';
import EditKompaWaterSensors from '@/views/Kompa/EditWaterSensorsView';
import EditKompaWeatherSensors from '@/views/Kompa/EditWeatherSensorsView';
import EditKompaSwitches from '@/views/Kompa/EditSwitchesView';
import EditKompaDoorWindowSensors
  from '@/views/Kompa/EditDoorWindowSensorsView';
import EditKompaMediaReceivers from '@/views/Kompa/EditMediaReceiversView';
import LegalTextsEditView from '@/views/LegalTexts/EditView';
import LegalTextsIndexView from '@/views/LegalTexts/IndexView';
import LegalTextsNewView from '@/views/LegalTexts/NewView';
import LegalTextsShowLayout from '@/views/LegalTexts/ShowLayout';
import LegalTextsShowView from '@/views/LegalTexts/ShowView';
import LegalTextsView from '@/views/LegalTextsView';
import LegalTextsContractRevisionsView
  from '@/views/LegalTexts/ContractRevisionsIndexView';
import LegalTextsProductRevisionsView
  from '@/views/LegalTexts/ProductRevisionsIndexView';
import LegalTextsProductFamilyRevisionsView
  from '@/views/LegalTexts/ProductFamilyRevisionsIndexView';
import NotFoundView from '@/views/Errors/NotFoundView';
import OfferRevisionsView from '@/views/Offers/RevisionsView';
import OffersEditRevisionView from '@/views/Offers/EditRevisionView';
import OffersEditView from '@/views/Offers/EditView';
import OffersIndexView from '@/views/Offers/IndexView';
import OffersNewRevisionView from '@/views/Offers/NewRevisionView';
import OffersNewView from '@/views/Offers/NewView';
import OffersShowView from '@/views/Offers/ShowView';
import OffersView from '@/views/OffersView';
import OrganizationsEditView from '@/views/Organizations/EditView';
import OrganizationsIndexView from '@/views/Organizations/IndexView';
import OrganizationsNewView from '@/views/Organizations/NewView';
import OrganizationsView from '@/views/OrganizationsView';
import ProductCategoriesEditView from '@/views/ProductCategories/EditView';
import ProductCategoriesIndexView from '@/views/ProductCategories/IndexView';
import ProductCategoriesNewView from '@/views/ProductCategories/NewView';
import ProductCategoriesShowView from '@/views/ProductCategories/ShowView';
import ProductCategoriesView from '@/views/ProductCategoriesView';
import ProductDesignArtistsEditView
  from '@/views/ProductDesignArtists/EditView';
import ProductDesignArtistsIndexView
  from '@/views/ProductDesignArtists/IndexView';
import ProductDesignArtistsNewView from '@/views/ProductDesignArtists/NewView';
import ProductDesignArtistsView from '@/views/ProductDesignArtistsView';
import ProductDesignCategoriesEditView
  from '@/views/ProductDesignCategories/EditView';
import ProductDesignCategoriesIndexView
  from '@/views/ProductDesignCategories/IndexView';
import ProductDesignCategoriesNewView
  from '@/views/ProductDesignCategories/NewView';
import ProductDesignCategoriesView
  from '@/views/ProductDesignCategoriesView';
import ProductDesignsView from '@/views/ProductDesignsView';
import ProductFamiliesCompatibilitiesView
  from '@/views/ProductFamilies/CompatibilitiesView';
import ProductFamiliesEditRevisionView
  from '@/views/ProductFamilies/EditRevisionView';
import ProductFamiliesEditView from '@/views/ProductFamilies/EditView';
import ProductFamiliesIndexView from '@/views/ProductFamilies/IndexView';
import ActiveRevisionsView
  from '@/views/ActiveRevisions/ActiveRevisionsView';
import ProductFamiliesNewRevisionView
  from '@/views/ProductFamilies/NewRevisionView';
import ProductFamiliesNewView from '@/views/ProductFamilies/NewView';
import ProductFamiliesRevisionsView
  from '@/views/ProductFamilies/RevisionsView';
import ProductFamiliesPxsdbFeaturesView
  from '@/views/ProductFamilies/PxsdbFeaturesView';

import ProductFamiliesShowLayout from '@/views/ProductFamilies/ShowLayout';
import ProductFamiliesShowView from '@/views/ProductFamilies/ShowView';
import ProductFamiliesView from '@/views/ProductFamiliesView';
import ProductsAccessoriesView from '@/views/Products/AccessoriesView';
import ProductsAvailabilitiesView from '@/views/Products/AvailabilitiesView';
import ProductsEditRevisionView from '@/views/Products/EditRevisionView';
import ProductsEditView from '@/views/Products/EditView';
import ProductsImportsView from '@/views/Products/ImportsView';
import ProductsErrorsView from '@/views/Products/ErrorsView';

import ProductsIndexView from '@/views/Products/IndexView';
import ProductsNewRevisionView from '@/views/Products/NewRevisionView';
import ProductsNewView from '@/views/Products/NewView';
import ProductsRecommendationsView from '@/views/Products/RecommendationsView';
import ProductsPxsdbFeaturesView from '@/views/Products/PxsdbFeaturesView';
import ProductsRevisionsView from '@/views/Products/RevisionsView';
import ProductsShowLayout from '@/views/Products/ShowLayout';
import ProductsShowView from '@/views/Products/ShowView';
import ProductStylesEditView from '@/views/ProductStyles/EditView';
import ProductStylesIndexView from '@/views/ProductStyles/IndexView';
import ProductStylesNewView from '@/views/ProductStyles/NewView';
import ProductStylesView from '@/views/ProductStylesView';
import ProductsView from '@/views/ProductsView';
import QueuedJobsView from '@/views/QueuedJobs';
import ServerErrorView from '@/views/Errors/ServerErrorView';
import TenantsEditView from '@/views/Tenants/EditView';
import TenantsIndexView from '@/views/Tenants/IndexView';
import TenantsNewView from '@/views/Tenants/NewView';
import TenantsShowView from '@/views/Tenants/ShowView';
import TenantsView from '@/views/TenantsView';
import UsersEditView from '@/views/Users/EditView';
import UsersIndexView from '@/views/Users/IndexView';
import UsersNewView from '@/views/Users/NewView';
import UsersView from '@/views/UsersView';

export default [
  {
    name: 'home',
    path: '/',
    component: HomeView,
    meta: { requireAuth: true },
    redirect: () => '/products',
  },
  {
    path: '/errors',
    component: ErrorsView,
    meta: { title: 'Error' },
    redirect: () => '/',
    children: [
      {
        name: 'not-found',
        path: 'not-found',
        component: NotFoundView,
        meta: { title: 'Not Found', scrollToTop: true },
      },
      {
        name: 'forbidden',
        path: 'forbidden',
        component: ForbiddenView,
        meta: { title: 'Forbidden', scrollToTop: true },
      },
      {
        name: 'server-error',
        path: 'server-error',
        component: ServerErrorView,
        meta: { title: 'Server Error', scrollToTop: true },
      },
    ],
  },
  {
    path: '/attachments',
    component: AttachmentsView,
    meta: { title: 'Attachments', requireAuth: true },
    children: [
      {
        name: 'attachments',
        path: '/attachments',
        component: AttachmentsIndexView,
        meta: { scrollToTop: true },
      },
      {
        name: 'new-attachment',
        path: 'new',
        component: AttachmentsNewView,
        meta: { title: 'New Attachment', scrollToTop: true },
      },
      {
        name: 'edit-attachment',
        path: ':id/edit',
        component: AttachmentsEditView,
        meta: { title: 'Edit Attachment', scrollToTop: true },
      },
    ],
  },
  {
    path: '/brands',
    component: BrandsView,
    meta: { title: 'Brands', requireAuth: true },
    children: [
      {
        name: 'brands',
        path: '/brands',
        component: BrandsIndexView,
        meta: { scrollToTop: true },
      },
      {
        name: 'new-brand',
        path: 'new',
        component: BrandsNewView,
        meta: { title: 'New Brand', scrollToTop: true },
      },
      {
        name: 'edit-brand',
        path: ':id/edit',
        component: BrandsEditView,
        meta: { title: 'Edit Brand', scrollToTop: true },
      },
    ],
  },
  {
    path: '/contracts',
    component: ContractsView,
    meta: { title: 'Contracts', requireAuth: true },
    children: [
      {
        name: 'contracts',
        path: '/contracts',
        component: ContractsIndexView,
        meta: { scrollToTop: true },
      },
      {
        name: 'new-contract',
        path: 'new',
        component: ContractsNewView,
        meta: { title: 'New Contract', scrollToTop: true },
      },
      {
        name: 'edit-contract',
        path: ':id/edit',
        component: ContractsEditView,
        meta: { title: 'Edit Contract', scrollToTop: true },
      },
      {
        name: 'new-contract-revision',
        path: ':contractId/revisions/new',
        component: ContractsNewRevisionView,
        meta: { title: 'New Revision', scrollToTop: true },
      },
      {
        name: 'edit-contract-revision',
        path: 'revisions/:id/edit',
        component: ContractsEditRevisionView,
        meta: { title: 'Edit Revision', scrollToTop: true },
      },
      {
        name: 'contract-revisions',
        path: ':id/revisions',
        component: ContractRevisionsView,
        meta: {
          layout: false,
          title: 'Revisions',
          scrollToTop: true,
        },
      },
      {
        name: 'contract',
        path: ':id',
        component: ContractShowView,
        meta: { title: 'Contract', scrollToTop: true },
      },
    ],
  },
  {
    path: '/kompa',
    component: KompaView,
    meta: { title: 'Kompa List', requireAuth: true },
    children: [
      {
        name: 'kompa',
        path: '/kompa',
        component: KompaIndexView,
        meta: { scrollToTop: true },
      },
      {
        name: 'create-kompa-product',
        path: '/kompa/create',
        component: CreateKompaProductView,
        meta: { scrollToTop: true },
      },
      {
        name: 'edit-kompa-product',
        path: ':id',
        component: EditKompaProduct,
        meta: { title: 'Edit Kompa Product', scrollToTop: true },
      },
      {
        name: 'edit-kompa-protocols',
        path: ':id/protocols',
        component: EditKompaProtocols,
        meta: { title: 'Edit Kompa Product', scrollToTop: true },
      },
      {
        name: 'edit-kompa-adapters',
        path: ':id/adapters',
        component: EditKompaAdapters,
        meta: { title: 'Edit Kompa Product', scrollToTop: true },
      },
      {
        name: 'edit-kompa-appliances',
        path: ':id/appliances',
        component: EditKompaAppliances,
        meta: { title: 'Edit Kompa Product', scrollToTop: true },
      },
      {
        name: 'edit-kompa-cameras',
        path: ':id/cameras',
        component: EditKompaCameras,
        meta: { title: 'Edit Kompa Product', scrollToTop: true },
      },
      {
        name: 'edit-kompa-door-locks',
        path: ':id/door-locks',
        component: EditKompaDoorLocks,
        meta: { title: 'Edit Kompa Product', scrollToTop: true },
      },
      {
        name: 'edit-kompa-climate-devices',
        path: ':id/climate-devices',
        component: EditKompaClimateDevices,
        meta: { title: 'Edit Kompa Product', scrollToTop: true },
      },
      {
        name: 'edit-kompa-extensions',
        path: ':id/extensions',
        component: EditKompaExtensions,
        meta: { title: 'Edit Kompa Product', scrollToTop: true },
      },
      {
        name: 'edit-kompa-gateway-bridges',
        path: ':id/gateway-bridges',
        component: EditKompaGatewayBridges,
        meta: { title: 'Edit Kompa Product', scrollToTop: true },
      },
      {
        name: 'edit-kompa-integrated-systems',
        path: ':id/integrated-systems',
        component: EditKompaIntegratedSystems,
        meta: { title: 'Edit Kompa Product', scrollToTop: true },
      },
      {
        name: 'edit-kompa-lightnings',
        path: ':id/lightnings',
        component: EditKompaLightnings,
        meta: { title: 'Edit Kompa Product', scrollToTop: true },
      },
      {
        name: 'edit-kompa-motion-sensors',
        path: ':id/motion-sensors',
        component: EditKompaMotionSensors,
        meta: { title: 'Edit Kompa Product', scrollToTop: true },
      },
      {
        name: 'edit-kompa-mounted-devices',
        path: ':id/mounted-devices',
        component: EditKompaMountedDevices,
        meta: { title: 'Edit Kompa Product', scrollToTop: true },
      },
      {
        name: 'edit-kompa-outdoor',
        path: ':id/outdoor',
        component: EditKompaOutdoor,
        meta: { title: 'Edit Kompa Product', scrollToTop: true },
      },
      {
        name: 'edit-kompa-remote-controls',
        path: ':id/remote-controls',
        component: EditKompaRemoteControls,
        meta: { title: 'Edit Kompa Product', scrollToTop: true },
      },
      {
        name: 'edit-kompa-internet-routers',
        path: ':id/internet-routers',
        component: EditKompaInternetRouters,
        meta: { title: 'Edit Kompa Product', scrollToTop: true },
      },
      {
        name: 'edit-kompa-shutter-and-gates',
        path: ':id/shutter-and-gates',
        component: EditKompaShutterAndGates,
        meta: { title: 'Edit Kompa Product', scrollToTop: true },
      },
      {
        name: 'edit-kompa-sirens',
        path: ':id/sirens',
        component: EditKompaSirens,
        meta: { title: 'Edit Kompa Product', scrollToTop: true },
      },
      {
        name: 'edit-kompa-smoke-sensors',
        path: ':id/smoke-sensors',
        component: EditKompaSmokeSensors,
        meta: { title: 'Edit Kompa Product', scrollToTop: true },
      },
      {
        name: 'edit-kompa-speakers',
        path: ':id/speakers',
        component: EditKompaSpeakers,
        meta: { title: 'Edit Kompa Product', scrollToTop: true },
      },
      {
        name: 'edit-kompa-various-sensors',
        path: ':id/various-sensors',
        component: EditKompaVariousSensors,
        meta: { title: 'Edit Kompa Product', scrollToTop: true },
      },
      {
        name: 'edit-kompa-switches',
        path: ':id/switches',
        component: EditKompaSwitches,
        meta: { title: 'Edit Kompa Product', scrollToTop: true },
      },
      {
        name: 'edit-kompa-door-window-sensors',
        path: ':id/door-window-sensors',
        component: EditKompaDoorWindowSensors,
        meta: { title: 'Edit Kompa Product', scrollToTop: true },
      },
      {
        name: 'edit-kompa-water-sensors',
        path: ':id/water-sensors',
        component: EditKompaWaterSensors,
        meta: { title: 'Edit Kompa Product', scrollToTop: true },
      },
      {
        name: 'edit-kompa-weather-sensors',
        path: ':id/weather-sensors',
        component: EditKompaWeatherSensors,
        meta: { title: 'Edit Kompa Product', scrollToTop: true },
      },
      {
        name: 'edit-kompa-media-receivers',
        path: ':id/media-receivers',
        component: EditKompaMediaReceivers,
        meta: { title: 'Edit Kompa Product', scrollToTop: true },
      },
    ],
  },
  {
    path: '/legal-texts',
    component: LegalTextsView,
    meta: { title: 'Legal Texts', requireAuth: true },
    children: [
      {
        name: 'legal-texts',
        path: '/legal-texts',
        component: LegalTextsIndexView,
        meta: { scrollToTop: true },
      },
      {
        name: 'new-legal-text',
        path: 'new',
        component: LegalTextsNewView,
        meta: { title: 'New Legal Text', scrollToTop: true },
      },
      {
        name: 'edit-legal-text',
        path: ':id/edit',
        component: LegalTextsEditView,
        meta: { title: 'Edit Legal Text', scrollToTop: true },
      },
      {
        path: ':id',
        component: LegalTextsShowLayout,
        meta: { title: 'Legal Text', scrollToTop: true },
        children: [
          {
            name: 'legal-text',
            path: '/legal-texts/:id',
            component: LegalTextsShowView,
            meta: { title: 'Legal Text', scrollToTop: true },
          },
          {
            name: 'legal-text-contract-revisions',
            path: 'contract-revisions',
            component: LegalTextsContractRevisionsView,
            meta: { title: 'Contract Revisions', scrollToTop: true },
          },
          {
            name: 'legal-text-product-revisions',
            path: 'product-revisions',
            component: LegalTextsProductRevisionsView,
            meta: { title: 'Product Revisions', scrollToTop: true },
          },
          {
            name: 'legal-text-product-family-revisions',
            path: 'product-family-revisions',
            component: LegalTextsProductFamilyRevisionsView,
            meta: { title: 'Product Family Revisions', scrollToTop: true },
          },
        ],
      },
    ],
  },
  {
    path: '/organizations',
    component: OrganizationsView,
    meta: { title: 'Organizations', requireAuth: true },
    children: [
      {
        name: 'organizations',
        path: '/organizations',
        component: OrganizationsIndexView,
        meta: { scrollToTop: true },
      },
      {
        name: 'new-organization',
        path: 'new',
        component: OrganizationsNewView,
        meta: { title: 'New Organization', scrollToTop: true },
      },
      {
        name: 'edit-organization',
        path: ':id/edit',
        component: OrganizationsEditView,
        meta: { title: 'Edit Organization', scrollToTop: true },
      },
    ],
  },
  {
    name: 'active-revisions',
    path: '/active-revisions',
    component: ActiveRevisionsView,
    meta: { title: 'Active Revisions', requireAuth: true },
  },
  {
    path: '/product-families',
    component: ProductFamiliesView,
    meta: { title: 'Product Families', requireAuth: true },
    children: [
      {
        name: 'product-families',
        path: '/product-families',
        component: ProductFamiliesIndexView,
        meta: { scrollToTop: true },
      },
      {
        name: 'new-standard-product-family',
        path: 'new-standard',
        component: ProductFamiliesNewView,
        meta: {
          title: 'New Product Family',
          isBundle: false,
          scrollToTop: true,
        },
      },
      {
        name: 'new-bundle-product-family',
        path: 'new-bundle',
        component: ProductFamiliesNewView,
        meta: {
          title: 'New Product Family',
          isBundle: true,
          scrollToTop: true,
        },
      },
      {
        name: 'edit-product-family',
        path: ':id/edit',
        component: ProductFamiliesEditView,
        meta: { title: 'Edit Product Family', scrollToTop: true },
      },
      {
        name: 'new-product-family-revision',
        path: ':productFamilyId/revisions/new',
        component: ProductFamiliesNewRevisionView,
        meta: { title: 'New Revision', scrollToTop: true },
      },
      {
        name: 'edit-product-family-revision',
        path: 'revisions/:id/edit',
        component: ProductFamiliesEditRevisionView,
        meta: { title: 'Edit Revision', scrollToTop: true },
      },
      {
        name: 'product-family-revisions',
        path: ':id/revisions',
        component: ProductFamiliesRevisionsView,
        meta: {
          layout: false,
          title: 'Revisions',
          scrollToTop: true,
        },
      },

      {
        path: ':id',
        component: ProductFamiliesShowLayout,
        meta: { title: 'Product Family', scrollToTop: true },
        children: [
          {
            name: 'product-family',
            path: '/product-families/:id',
            component: ProductFamiliesShowView,
            meta: { scrollToTop: true },
          },
          {
            name: 'product-family-compatibilities',
            path: 'compatibilities',
            component: ProductFamiliesCompatibilitiesView,
            meta: { title: 'Compatibilities', scrollToTop: true },
          },
          {
            name: 'product-family-pxsdb-features',
            path: '/pxsdb-features',
            component: ProductFamiliesPxsdbFeaturesView,
            meta: {
              title: 'PXSDB Features',
              scrollToTop: true,
            },
          },
        ],
      },
    ],
  },
  {
    path: '/products',
    component: ProductsView,
    meta: { title: 'Products', requireAuth: true },
    children: [
      {
        name: 'products',
        path: '/products',
        component: ProductsIndexView,
        meta: { scrollToTop: true },
      },
      {
        name: 'new-standard-product',
        path: 'new-standard',
        component: ProductsNewView,
        meta: {
          title: 'New Product',
          isBundle: false,
          scrollToTop: true,
        },
      },
      {
        name: 'new-bundle-product',
        path: 'new-bundle',
        component: ProductsNewView,
        meta: {
          title: 'New Product',
          isBundle: true,
          scrollToTop: true,
        },
      },
      {
        name: 'edit-product',
        path: ':id/edit',
        component: ProductsEditView,
        meta: { title: 'Edit Product', scrollToTop: true },
      },
      {
        name: 'new-product-revision',
        path: ':productId/revisions/new',
        component: ProductsNewRevisionView,
        meta: { title: 'New Revision', scrollToTop: true },
      },
      {
        name: 'edit-product-revision',
        path: 'revisions/:id/edit',
        component: ProductsEditRevisionView,
        meta: { title: 'Edit Revision', scrollToTop: true },
      },
      {
        name: 'product-revisions',
        path: ':id/revisions',
        component: ProductsRevisionsView,
        meta: {
          layout: false,
          title: 'Revisions',
          scrollToTop: true,
        },
      },
      {
        path: ':id',
        component: ProductsShowLayout,
        meta: { title: 'Product', scrollToTop: true },
        children: [
          {
            name: 'product',
            path: '/products/:id',
            component: ProductsShowView,
            meta: { scrollToTop: true },
          },
          {
            name: 'product-recommendations',
            path: 'recommendations',
            component: ProductsRecommendationsView,
            meta: { title: 'Recommendations', scrollToTop: true },
          },
          {
            name: 'product-accessories',
            path: 'accessories',
            component: ProductsAccessoriesView,
            meta: { title: 'Accessories', scrollToTop: true },
          },
          {
            name: 'product-availabilities',
            path: 'availabilities',
            component: ProductsAvailabilitiesView,
            meta: { title: 'Availabilities', scrollToTop: true },
          },
          {
            name: 'product-imports',
            path: 'imports',
            component: ProductsImportsView,
            meta: { title: 'Imports', scrollToTop: true },
          },
          {
            name: 'product-errors',
            path: 'errors',
            component: ProductsErrorsView,
            meta: { title: 'Errors', scrollToTop: true },
          },
          {
            name: 'product-pxsdb-features',
            path: 'pxsdb-features',
            component: ProductsPxsdbFeaturesView,
            meta: { title: 'PXSDBFeatures', scrollToTop: true },
          },
        ],
      },
    ],
  },
  {
    path: '/product-styles',
    component: ProductStylesView,
    meta: { title: 'Product Styles', requireAuth: true },
    children: [
      {
        name: 'product-styles',
        path: '/product-styles',
        component: ProductStylesIndexView,
        meta: { scrollToTop: true },
      },
      {
        name: 'new-product-style',
        path: 'new',
        component: ProductStylesNewView,
        meta: { title: 'New Product Style', scrollToTop: true },
      },
      {
        name: 'edit-product-style',
        path: ':id/edit',
        component: ProductStylesEditView,
        meta: { title: 'Edit Product Style', scrollToTop: true },
      },
    ],
  },
  {
    path: '/product-designs',
    component: ProductDesignsView,
    name: 'product-designs',
    redirect: () => '/product-designs/artists',
    children: [
      {
        path: 'artists',
        component: ProductDesignArtistsView,
        meta: { title: 'Product Design Artists', requireAuth: true },
        children: [
          {
            name: 'product-design-artists',
            path: '/product-designs/artists',
            component: ProductDesignArtistsIndexView,
            meta: { scrollToTop: true },
          },
          {
            name: 'new-product-design-artist',
            path: 'new',
            component: ProductDesignArtistsNewView,
            meta: { title: 'New Product Design Artist', scrollToTop: true },
          },
          {
            name: 'edit-product-design-artist',
            path: ':id/edit',
            component: ProductDesignArtistsEditView,
            meta: { title: 'Edit Product Design Artist', scrollToTop: true },
          },
        ],
      },
      {
        path: 'categories',
        component: ProductDesignCategoriesView,
        meta: { title: 'Product Design Categories', requireAuth: true },
        children: [
          {
            name: 'product-design-categories',
            path: '/product-designs/categories',
            component: ProductDesignCategoriesIndexView,
            meta: { scrollToTop: true },
          },
          {
            name: 'new-product-design-category',
            path: 'new',
            component: ProductDesignCategoriesNewView,
            meta: { title: 'New Product Design Category', scrollToTop: true },
          },
          {
            name: 'edit-product-design-category',
            path: ':id/edit',
            component: ProductDesignCategoriesEditView,
            meta: { title: 'Edit Product Design Category', scrollToTop: true },
          },
        ],
      },
    ],
  },
  {
    path: '/categories',
    component: ProductCategoriesView,
    meta: { title: 'Product Categories', requireAuth: true },
    children: [
      {
        name: 'product-categories',
        path: '/categories',
        component: ProductCategoriesIndexView,
        meta: { scrollToTop: true },
      },
      {
        name: 'product-categories-for-tenant',
        path: 'for-tenant/:tenantId',
        component: ProductCategoriesShowView,
        meta: { scrollToTop: true },
      },
      {
        name: 'new-product-category',
        path: 'new',
        component: ProductCategoriesNewView,
        meta: { scrollToTop: true },
      },
      {
        name: 'edit-product-category',
        path: ':id/edit',
        component: ProductCategoriesEditView,
        meta: { scrollToTop: true },
      },
      {
        name: 'product-category',
        path: ':id',
        component: ProductCategoriesShowView,
        meta: { scrollToTop: true },
      },
    ],
  },
  {
    path: '/offers',
    component: OffersView,
    meta: { title: 'Offers', requireAuth: true },
    children: [
      {
        name: 'offers',
        path: '/offers',
        component: OffersIndexView,
        meta: { scrollToTop: true },
      },
      {
        name: 'new-offer',
        path: 'new',
        component: OffersNewView,
        meta: { title: 'New Offer', scrollToTop: true },
      },
      {
        name: 'edit-offer',
        path: ':id/edit',
        component: OffersEditView,
        meta: { title: 'Edit Offer', scrollToTop: true },
      },
      {
        name: 'new-offer-revision',
        path: ':offerId/revisions/new',
        component: OffersNewRevisionView,
        meta: { title: 'New Revision', scrollToTop: true },
      },
      {
        name: 'edit-offer-revision',
        path: 'revisions/:id/edit',
        component: OffersEditRevisionView,
        meta: { title: 'Edit Revision', scrollToTop: true },
      },
      {
        name: 'offer-revisions',
        path: ':id/revisions',
        component: OfferRevisionsView,
        meta: {
          layout: false,
          title: 'Revisions',
          scrollToTop: true,
        },
      },
      {
        name: 'offer',
        path: ':id',
        component: OffersShowView,
        meta: { title: 'Offer', scrollToTop: true },
      },
    ],
  },
  {
    path: '/tenants',
    component: TenantsView,
    meta: { title: 'Tenants', requireAuth: true },
    children: [
      {
        name: 'tenants',
        path: '/tenants',
        component: TenantsIndexView,
        meta: { scrollToTop: true },
      },
      {
        name: 'new-tenant',
        path: 'new',
        component: TenantsNewView,
        meta: { title: 'New Tenant', scrollToTop: true },
      },
      {
        name: 'edit-tenant',
        path: ':id/edit',
        component: TenantsEditView,
        meta: { title: 'Edit Tenant', scrollToTop: true },
      },
      {
        name: 'tenant',
        path: ':id',
        component: TenantsShowView,
        meta: { title: 'Tenant', scrollToTop: true },
      },
    ],
  },
  {
    path: '/users',
    component: UsersView,
    meta: { title: 'Users', requireAuth: true },
    children: [
      {
        name: 'users',
        path: '/users',
        component: UsersIndexView,
        meta: { scrollToTop: true },
      },
      {
        name: 'new-user',
        path: 'new',
        component: UsersNewView,
        meta: { title: 'New User', scrollToTop: true },
      },
      {
        name: 'edit-user',
        path: ':id/edit',
        component: UsersEditView,
        meta: { title: 'Edit User', scrollToTop: true },
      },
    ],
  },
  {
    path: '/maintenance',
    component: MaintenanceView,
    meta: { title: 'Maintenance', requireAuth: true },
    children: [
      {
        name: 'maintenance',
        path: '/maintenance',
        component: MaintenanceIndexView,
      },
    ],
  },
  {
    path: '/imports',
    component: ImportReportsView,
    meta: { title: 'Imports', requireAuth: true },
    children: [
      {
        name: 'import-reports',
        path: '/imports',
        component: ImportReportsIndexView,
        meta: { scrollToTop: true },
      },
      {
        name: 'import-report',
        path: ':id',
        component: ImportReportsShowView,
        meta: { title: 'Import', scrollToTop: true },
      },
    ],
  },
  {
    path: '/queued-jobs',
    name: 'queued-jobs',
    component: QueuedJobsView,
    meta: { title: 'Warteschlange', requireAuth: true },
  },
  {
    path: '*',
    component: NotFoundView,
    meta: { title: 'Not Found', scrollToTop: true },
  },
];



// WEBPACK FOOTER //
// ./router/routes.js